import * as React from 'react'
import * as Styles from './Home.style'
import { HomeContent } from './components/HomeContent/HomeContent'
import SearchBar from './components/HomeSearchBar/HomeSearchBar'
import Nav from '../../components/Nav/Nav'
import { HttpServer } from '@/services/server'
import { withRouter } from 'react-router-dom'
import HomeActiveCoupon from './components/HomeActiveCoupon/HomeActiveCoupon'
import FloatCoupon from '../../plugins/coupon/floatCoupon'
import HomeCategory from './components/HomeCategory/HomeCategory'
import CategoryPage from '../Category/Category'
import { MusicPlayer } from '../../plugins/MusicPlayer/MusicPlayer'
import { RegisterElement } from '../../services/hotspotReport'
import { setUbtInit, reportViewEvent } from '@weike/operation-report'
import NewHomeActiveCoupon from './components/HomeActiveCoupon/NewHomeActiveCoupon'
import { isIOS } from '../../utils/tools'

interface HomeState {
  categoryMenu: IcategoryMenuItem[]
  loadedData: boolean
  isNewWindow: boolean
  newPopupData: INewWindow
  oldPopupData: IOldWindow
}

interface IcategoryMenuItem {
  id: number
  img_url: string
  name: string
}

interface INewWindow {
  window_id: number
  window_style_id: number
  strategy_id: number
  scene: string
  image_url: string
  activity_url: string
}
interface IOldWindow {
  id: string
  img_url: string
  index: number
  link: string
  open_test: boolean
}

@(withRouter as any)
export default class HomePage extends React.Component<any, HomeState> {
  public constructor(props: any) {
    super(props)
    this.state = {
      categoryMenu: [],
      loadedData: false,
      isNewWindow: false,
      newPopupData: {
        window_id: 0,
        window_style_id: 0,
        strategy_id: 0,
        scene: '',
        image_url: '',
        activity_url: ''
      },
      oldPopupData: {
        id: '',
        img_url: '',
        index: 0,
        link: '',
        open_test: false
      }
    }
  }

  public componentDidMount() {
    this.sendPvEvent()

    this.goToUserLastTimeScrollPosition() // 获取上次滚动位置

    this.getCategoryMenu()

    window.addEventListener('scroll', this.handleScroll)

    setUbtInit('opu2', 'home')

    this.getPopwindowType() // 获取首页新旧弹窗分流信息

    /** 访问埋点 */
    setTimeout(() => {
      try {
        // @ts-ignore
        if (window.TorDataService) {
          // @ts-ignore
          window.TorDataService.emitAction('hp_page_v')
        }
      } catch (error) {
        console.log(error)
      }
    }, 300)
  }

  public sendPvEvent() {
    setTimeout(() => {
      // 考虑到太短被关掉没有意义，设置一个小延时
      if (/outside_site/.test(window.location.href)) {
        // 劫持返回首页
        reportViewEvent(RegisterElement.home_enter_hijack)
      } else {
        // 直接进入首页
        reportViewEvent(RegisterElement.home_enter_normal)
      }
    }, 500)
  }

  public getCategoryMenu() {
    // 获取类目
    HttpServer.getCategoryRecommendBottomMenu().then(res => {
      if (res.data.code === 0) {
        const categoryArr = res.data.data.category
        const result = categoryArr.filter(item => item.id !== 0)
        this.setState({
          categoryMenu: result
        })
      }
    })
  }

  public getScrollTopElement(): HTMLElement {
    return document.documentElement as HTMLElement
  }
  public handleScroll = () => {
    this.getScrollTop()
  }
  public getScrollTop() {
    const userScrollTop = this.getScrollTopElement().scrollTop
    sessionStorage.setItem('WKIndex/scrollTop', userScrollTop.toString())
  }
  public goToUserLastTimeScrollPosition() {
    const getLastTimeScolltop: string | null = window.sessionStorage.getItem('WKIndex/scrollTop')
    // 记录并回到上次用户滚动到的位置(如果有)
    if (getLastTimeScolltop && getLastTimeScolltop! == null) {
      // 由于上了乾坤，暂时去掉页面滚动，等项目完全迁移到新框架上，在打开滚动。
      // setTimeout(() => {
      // if (isIOS()) {
      // window.scrollTo(0, parseFloat(getLastTimeScolltop))
      // }
      // }, 300)
    }
  }
  // 获取h5首页展示的弹窗信息(新/旧弹窗)
  public getPopwindowType() {
    HttpServer.getWindowInfo().then(res => {
      // 不展示弹窗的时候code返回也是0，所以需要多加返回data中是否有数据的判断
      if (res.data.code === 0 && Object.keys(res.data.data).length) {
        if (res.data.popwindow_type === 'new_window') {
          this.setState({ newPopupData: res.data.data, loadedData: true, isNewWindow: true })
        } else {
          this.setState({ oldPopupData: res.data.data, loadedData: true, isNewWindow: false })
        }
      }
    })
  }
  public render() {
    return (
      <div className={Styles.HomePage}>
        {
          !/redirect_url/.test(window.location.search) &&
          this.state.loadedData &&
          (this.state.isNewWindow ? <NewHomeActiveCoupon {...this.state.newPopupData} /> : <HomeActiveCoupon {...this.state.oldPopupData} />)
        }

        {
          !/category/.test(window.location.pathname) && <FloatCoupon /> // 顶部广告栏
        }

        {/* <div className={Styles.searchWrap}>
          <SearchBar />
        </div> */}

        {this.state.categoryMenu && <HomeCategory content={this.state.categoryMenu} />}

        {!/category/.test(window.location.pathname) && <HomeContent />}

        {/category/.test(window.location.pathname) && <CategoryPage />}

        <MusicPlayer />
        <Nav />
      </div>
    )
  }
  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Home.tsx